<template>
  <v-dialog v-model="eventBus.showContactModal" max-width="560" scrollable>
    <div class="modal-wrapper">
      <!-- Close button -->
      <button class="close-btn" @click="eventBus.showContactModal = false">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <v-card class="modal-card" flat>
        <v-card-text class="modal-body">
          <!-- Title -->
          <h2 class="modal-title">{{ $t('contact.title') }}</h2>

          <!-- Spacer -->
          <div class="modal-spacer"></div>

          <!-- Contact Info -->
          <div class="contact-info">
            <!-- Phone row -->
            <div class="phone-row">
              <div class="contact-block">
                <span class="contact-label">{{ $t('contact.labelMobile') }}</span>
                <a href="tel:+37379463041" class="contact-value">373-794-63-041</a>
              </div>
              <div class="contact-block">
                <span class="contact-label">{{ $t('contact.labelStationary') }}</span>
                <a href="tel:+37322549954" class="contact-value">022-54-99-54</a>
              </div>
            </div>

            <!-- Email -->
            <div class="contact-block">
              <span class="contact-label">{{ $t('contact.labelEmail') }}</span>
              <a href="mailto:contact@investbroker.com" class="contact-value">contact@investbroker.com</a>
            </div>

            <!-- Address -->
            <div class="contact-block">
              <span class="contact-label">{{ $t('contact.labelOffice') }}</span>
              <span class="contact-value">{{ $t('contact.address') }}</span>
            </div>

            <!-- Schedule -->
            <div class="contact-block">
              <span class="contact-label">{{ $t('contact.labelSchedule') }}</span>
              <span class="contact-value">{{ $t('contact.schedule') }}</span>
            </div>
          </div>

          <!-- Spacer -->
          <div class="modal-spacer"></div>

          <!-- Company Info -->
          <div class="company-info">
            <div class="company-block">
              <span class="company-label">{{ $t('contact.companyName') }}</span>
              <span class="company-value">IDNO: 1013600004577</span>
            </div>
            <div class="company-block">
              <span class="company-label">{{ $t('contact.licenseLabel') }}</span>
              <span class="company-value">{{ $t('contact.licenseValue') }}</span>
            </div>
            <div class="company-block">
              <span class="company-label">{{ $t('contact.adminLabel') }}</span>
              <span class="company-value">{{ $t('contact.adminName') }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- CTA Block -->
      <div class="modal-cta">
        <h3 class="cta-title">{{ $t('contact.ctaTitle') }}</h3>
        <a class="cta-button" href="#answers" @click="eventBus.showContactModal = false">
          {{ $t('contact.ctaBtn') }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.5 8H12.5M12.5 8L8.5 4M12.5 8L8.5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/eventBus'

export default {
  name: 'ContactModal',
  setup() {
    return { eventBus }
  }
}
</script>

<style scoped>
.modal-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.close-btn {
  position: absolute;
  top: 0;
  right: -48px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F1F1F180;
  border: none;
  color: #343330;
  cursor: pointer;
  z-index: 10;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.modal-card {
  overflow: hidden;
  max-height: 85vh;
  border-radius: 8px;
}

.modal-body {
  padding: 16px 16px 36px;
  display: flex;
  flex-direction: column;
  min-height: 700px;
}

.modal-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 36px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(28, 165, 190);
  margin: 0;
}

.modal-spacer {
  flex: 1;
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.phone-row {
  display: flex;
  gap: 40px;
}

.contact-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-label {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 12px;
  color: rgb(125, 125, 125);
  text-transform: uppercase;
}

.contact-value {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 24px;
  color: rgb(46, 46, 46);
  text-decoration: none;
}

a.contact-value {
  text-decoration: underline;
}

/* Company Info */
.company-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.company-label {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 12px;
  color: rgb(125, 125, 125);
  text-transform: uppercase;
}

.company-value {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgb(125, 125, 125);
}

.company-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* CTA Block */
.modal-cta {
  background: rgb(28, 165, 190);
  border-radius: 8px;
  padding: 16px 16px 36px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cta-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(241, 241, 241);
  margin: 0;
}

.cta-button {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: rgb(241, 241, 241);
  color: rgb(46, 46, 46);
  border: none;
  border-radius: 4px;
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: background 0.2s ease;
  width: fit-content;
}

.cta-button:hover {
  background: rgb(255, 255, 255);
}

/* Responsive */
@media (max-width: 960px) {
  .close-btn {
    top: 8px;
    right: 8px;
    color: rgb(46, 46, 46);
  }

  .modal-body {
    padding: 40px 20px 20px !important;
    min-height: auto;
  }

  .modal-title {
    font-size: 24px;
    line-height: 32px;
  }

  .modal-spacer {
    min-height: 40px;
    flex: none;
  }

  .contact-value {
    font-size: 18px;
    line-height: 26px;
  }

  .modal-cta {
    padding: 24px 20px;
  }

  .cta-title {
    font-size: 24px;
    line-height: 32px;
  }
}
</style>
